import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
    selector: '[mzDeclensions]'
})
export class MzDeclensionsDirective implements OnInit {
    @Input() mzDeclensions: string;
    @Input() count: number;
    @Input() static = true;


    constructor(private el: ElementRef) {
    }

    ngOnInit() {
        const arr = this.mzDeclensions.split(',');
        const hash = { 1: arr[0], 2: arr[1], 5: arr[2] };
        let x = this.count >= 10 && this.count <= 20
            ? 5
            : this.count % 10;
        if (this.count > 999) {
            x = this.count % 100;
        }
        const keys = Object.keys(hash).sort();
        this.el.nativeElement.innerHTML = !x ? `${this.count} ${hash[keys.pop()]}` : keys.reduce((result, key) => {
                return x >= +key && this.static
                    ? `${this.count} ${hash[key]}`
                    : x >= +key && !this.static
                        ? hash[key]
                        : result;
            }, '');
    }

}
